import type { Client } from '@bugsnag/js';

/**
 * Registers the ResizeObserver filter with Bugsnag so it is not stored in runtime config
 * (runtime config must be serializable). Run after nuxt-bugsnag plugin (order: 10).
 */
export default defineNuxtPlugin((nuxtApp) => {
  const bugsnag = (nuxtApp as { $bugsnag?: Client }).$bugsnag;
  if (!bugsnag?.addOnError) return;

  bugsnag.addOnError((event: { originalError?: Error; errors?: Array<{ errorMessage?: string }> }) => {
    // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
    return !(
      (event.originalError instanceof Error && event.originalError.message.search('ResizeObserver') >= 0)
      || ((event.errors?.[0]?.errorMessage?.search('ResizeObserver') ?? -1) >= 0)
    );
  });
});
